<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>员工信息:</h4>
      <div class="box">
        <el-form label-width="150px">
          <el-row>
            <el-col :span="11">
              <el-form-item label="工号：" required>
                <el-input v-model="employee_no" placeholder="工号" @blur="employeeNoChange"
                          :disabled="isDetail || isEdit">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="姓名：" required>
                <el-input v-model="employee_name" placeholder="姓名" disabled>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="厂区：" required>
                <el-select v-model="before_factory_id" placeholder="厂区"  filterable disabled>
                  <el-option v-for="item in factoryList" :key="item.id" :label="item.name" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="公司：" required>
                <el-input v-model="company_name" placeholder="公司" disabled/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="部门：" required>
                <el-cascader v-model="before_department_ids" :options="deptCascader" disabled
                             :props="beforeCascaderProp" :show-all-levels="true" style="width: 100%"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="岗位：" required>
                <el-input v-model="before_job_id" placeholder="岗位" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="职务：" required>
                <el-input v-model="before_position_id" placeholder="职务" disabled>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <h4>外调信息:</h4>
      <div class="box">
        <el-form label-width="150px" :disabled="isDetail || isEdit">
         <el-row>
           <el-col :span="11">
             <el-form-item label="外调时间：" required>
               <el-date-picker v-model="record_item_time" type="date"
                               value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
             </el-form-item>
           </el-col>
         </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="外调厂区：" required>
                <el-select v-model="factory_id" placeholder="外调厂区"  @change="getCompany"  filterable>
                  <el-option v-for="item in factoryList" :key="item.id" :label="item.name" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="外调公司：" required>
                <el-select v-model="company_id" placeholder="外调公司"  filterable>
                  <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="部门：" required>
                <el-cascader v-model="department_ids" :options="aterDeptCascader"
                             :props="CascaderProp" :show-all-levels="true" style="width: 100%"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="岗位：" required>
                <el-input  v-model="job_id" placeholder="岗位" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="职务：" required>
                <el-input  v-model="position_id" placeholder="职务" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
<!--      <el-form label-width="150px">
        <el-row>
          <el-col>
            <h4>
              <span>薪资调整: &lt;!&ndash;<small style="font-size: smaller;">（本月调整薪资后次月生效）</small>&ndash;&gt;</span>
              <el-switch
                  v-model="is_already_change_salary"
                  :disabled="isEdit || isDetail">
              </el-switch>
            </h4>
          </el-col>
          <el-col :span="11">
            <el-form-item label="生效月份：" required v-if="is_already_change_salary" >
              <el-date-picker
                  :disabled="isEdit || isDetail"
                  v-model="change_item_time"
                  type="month"
                  value-format="YYYY-MM"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="box">
        <el-form label-width="110px" :disabled="isEdit || is_already_change_salary===false">
          <el-row>
            <el-col :span="8" :offset="4">
              <el-form-item label="异动前：">
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="3">
              <el-form-item label="异动后：">
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="员工类型：">
                <el-select v-model="job_change.before_type" disabled placeholder="员工类型">
                  <el-option v-for="item in options.employee_type_options"
                             :key="item.value"
                             :value="item.value"
                             :label="item.label"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="员工类型：" required>
                <el-select v-model="job_change.after_type" placeholder="员工类型" :disabled="isDetail">
                  <el-option v-for="item in options.employee_type_options"
                             :key="item.value"
                             :value="item.value"
                             :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="薪资类型：">
                <el-select v-model="salary_change.before_salary_type" disabled
                           placeholder="薪资类型">
                  <el-option v-for="item in options.salary_type_options"
                             :key="item.value"
                             :value="item.value"
                             :label="item.label"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="薪资类型：" required>
                <el-select v-model="salary_change.after_salary_type" placeholder="薪资类型" :disabled="isDetail"
                           @change="salaryTypeChange">
                  <el-option v-for="item in options.salary_type_options"
                             :key="item.value"
                             :value="item.value"
                             :label="item.label"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="薪资(底薪)：">
                <el-input v-model="salary_change.before_salary" disabled placeholder="薪资(底薪)"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="薪资(底薪)：" required>
                <el-input v-model="salary_change.after_salary" placeholder="薪资(底薪)"
                          :disabled="isDetail" type="number"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="标准津贴：">
                <el-input v-model="salary_change.before_salary_allowance" disabled placeholder="标准津贴"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="标准津贴：" required>
                <el-input v-model="salary_change.after_salary_allowance" placeholder="标准津贴"
                          :disabled="isDetail" type="number"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="标准补贴：">
                <el-input v-model="salary_change.before_salary_subsidy" disabled placeholder="标准补贴"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="标准补贴：" required>
                <el-input v-model="salary_change.after_salary_subsidy" placeholder="标准补贴"
                          :disabled="isDetail" type="number"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item label="补贴选项：">
                <el-checkbox v-model="salary_change.before_is_customization_subsidy" disabled>自定义补贴</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item label="补贴选项：" required>
                <el-checkbox v-model="salary_change.after_is_customization_subsidy" :disabled="isDetail">自定义补贴
                </el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item>
                <el-checkbox v-model="salary_change.before_is_salary_car" disabled
                             label="车补"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item required>
                <el-checkbox :disabled="!salary_change.after_is_customization_subsidy || isDetail"
                             v-model="salary_change.after_is_salary_car"
                             label="车补"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item>
                <el-checkbox v-model="salary_change.before_is_salary_house" disabled
                             label="房补"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item required>
                <el-checkbox :disabled="!salary_change.after_is_customization_subsidy  || isDetail"
                             v-model="salary_change.after_is_salary_house" label="房补"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item>
                <el-checkbox v-model="salary_change.before_is_salary_on_job" disabled label="在职奖"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item required>
                <el-checkbox :disabled="!salary_change.after_is_customization_subsidy  || isDetail"
                             v-model="salary_change.after_is_salary_on_job" label="在职奖"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item>
                <el-checkbox v-model="salary_change.before_is_salary_full_attendance" disabled label="全勤奖"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item required>
                <el-checkbox :disabled="!salary_change.after_is_customization_subsidy  || isDetail"
                             v-model="salary_change.after_is_salary_full_attendance" label="全勤奖"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8" :offset="3">
              <el-form-item>
                <el-checkbox v-model="salary_change.before_is_salary_work_year" disabled label="工龄奖"/>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="3">
              <el-form-item required>
                <el-checkbox :disabled="!salary_change.after_is_customization_subsidy  || isDetail"
                             v-model="salary_change.after_is_salary_work_year" label="工龄奖"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>-->
      <label style="margin-left: 5px;font-weight: bold">其它附件:</label>
      <div class="box">
        <el-form label-width="150px"  :disabled="isDetail || isEdit">
          <el-row>
            <el-col :span="12">
              <el-form-item label="附件：">
                <kf-file-upload v-model="file_id" :init-file="fileList"
                                @fileChange="fileChange"
                                :limit="10" :showTotalCnt="true"></kf-file-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="附件照片：">
                <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="">
                <FrameItem v-model="attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj"></FrameItem>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="display: flex;justify-content: center;margin-bottom: 20px">
        <el-button type="primary" @click="saveButton" v-if="!isEdit">保存</el-button>
      </div>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisibleTwo" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: "EmployeeTransferRecordAdd",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      CascaderProp: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly:true
      },
      beforeCascaderProp: {
        emitPath: false,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      isDetail: false,
      isEdit: false,
      change_item_id: '',
      deptCascader: [],
      aterDeptCascader: [],
      factoryList: [],
      companyList: [],
      options: {
        change_item_id_options: [],
        /*status_options:[],*/
        position_options: [],
        employee_type_options: [],
        rank_options: [],
        salary_type_options: []
      },
      change_item_time: '',
      remark: '',
      employee_no: '',
      employee_name: '',
      company_name: '',
      before_factory_id: '',
      before_company_id: '',
      before_department_ids: '',
      before_position_id: '',
      before_job_id: '',
      factory_id: '',
      company_id: '',
      department_ids: '',
      position_id: '',
      job_id: '',
      job_change: {
        before_type: '',
        after_type: '',
        /*before_status: '',
        after_status: '',*/
        before_position: '',
        after_position: '',
        /*  before_level: '',
          after_level: '',*/
        before_dept: '',
        after_dept: ''
      },
      is_already_change_salary: false,
      record_item_time: '',
      salary_change: {
        before_salary_type: '',
        after_salary_type: '',
        before_salary: '',
        after_salary: '',
        before_salary_allowance: '',
        after_salary_allowance: '',
        before_salary_subsidy: '',
        after_salary_subsidy: '',
        before_is_customization_subsidy: false,
        after_is_customization_subsidy: false,
        before_is_salary_car: false,
        after_is_salary_car: false,
        before_is_salary_house: false,
        after_is_salary_house: false,
        before_is_salary_on_job: false,
        after_is_salary_on_job: false,
        before_is_salary_full_attendance: false,
        after_is_salary_full_attendance: false,
        before_is_salary_work_year: false,
        after_is_salary_work_year: false
      },
      file_id: [],
      fileList: [],
      dialogVisibleTwo:false,
      uploadImgObj:{
        component: 'image_upload',
        limit: 1,
      },
      attach_photo_id:'',
      attach_photo_id_obj:[],
      positionOption:[],
      departmentList:[]
    }
  },
  methods: {
    //获取厂区
    async getFactory() {
      let params = {modelId: "hr_document"}
      this.factoryList = await this.$http('sysFactoryService.getAllFactory', params);
    },
    //获取公司
    async getCompany() {
      this.company_id = '';
      let params = {factory_id: this.factory_id}
      this.companyList = await this.$http('sysFactoryService.getCompanyByFactory', params);
      await this.getAfterDepartment();
    },
    //获取文件
    async getAttachments() {
      let params = {
        file_id: this.file_id
      }
      console.log('aaa', params)
      this.formData = await this.$http('fileService.getAttachments', params)
      if (this.formData) {
        this.fileList = this.formData.attachmentsList;
      }
    },

    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.file_id = ids;
    },

    async saveButton() {
      let flag = this.checkForm()
      if (!flag) {
        return
      }
      let params = {
        id: this.parentData.id,
        is_already_change_salary: this.is_already_change_salary,
        change_item_id: this.change_item_id,
        remark: this.remark,
        change_item_time:this.change_item_time,
        employee_no: this.employee_no,
        employee_name: this.employee_name,
        factory_id: this.factory_id,
        company_id: this.company_id,
        department_ids: this.department_ids,
        position_id: this.position_id,
        job_id: this.job_id,
        job_change: this.job_change,
        salary_change: this.salary_change,
        file_id: this.file_id,
        record_item_time: this.record_item_time,
        attach_photo_id: this.attach_photo_id
      }
      await this.$http("employeeTransferService.transfer", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    checkForm() {
      if (this.employee_no == null || this.employee_no === '') {
        this.$message.error("请输入员工工号！");
        return false;
      }
      if(this.record_item_time == null || this.record_item_time === ''){
        this.$message.error("请选择外调时间！");
        return false;
      }
      if(this.record_item_time == null || this.record_item_time === ''){
        this.$message.error("请选择外调时间！");
        return false;
      }
      if(this.factory_id == null || this.factory_id === ''){
        this.$message.error("请选择外调厂区！");
        return false;
      }
      if(this.company_id == null || this.company_id === ''){
        this.$message.error("请选择外调公司！");
        return false;
      }
      if(this.department_ids == null || this.department_ids === ''){
        this.$message.error("请选择外调部门！");
        return false;
      }
      if(this.job_id == null || this.job_id === ''){
        this.$message.error("请填写外调岗位！");
        return false;
      }
      if(this.position_id == null || this.position_id === ''){
        this.$message.error("请填写外调职务！");
        return false;
      }

      /*if (this.is_already_change_salary) {
        if (this.salary_change.after_salary_type == null || this.salary_change.after_salary_type === '' ||
            this.salary_change.after_salary == null || this.salary_change.after_salary === '' ||
            this.salary_change.after_salary_allowance == null || this.salary_change.after_salary_allowance === '' ||
            this.salary_change.after_salary_subsidy == null || this.salary_change.after_salary_subsidy === ''
        ) {
          this.$message.error("请将薪资调整填写完整！");
          return false;
        }
      }*/

      return true;
    },
    async getData() {
      let params = {
        id: this.parentData.id
      }
      if (params.id !== undefined) {
        let data = await this.$http("employeeTransferService.getById", params);
        this.change_item_id = data.change_item_id
        this.is_already_change_salary = Boolean(data.is_already_change_salary)
        this.remark = data.remark
        this.change_item_time = data.change_item_time
        this.employee_no = data.employee_no
        this.employee_name = data.employee_name
        this.before_factory_id = data.before_factory_id;
        this.before_company_id = data.before_company_id;
        this.before_department_ids = data.before_dept;
        this.before_position_id = data.before_position;
        this.before_job_id = data.before_job;
        this.factory_id = data.after_factory_id;
        this.company_id = data.after_company_id;
        this.company_name = data.company_name;
        this.department_ids = data.after_dept;
        this.position_id = data.after_position;
        this.job_id = data.after_job;
        this.job_change.before_type = data.before_type
        this.job_change.after_type = data.after_type
        this.job_change.before_position = data.before_position
        this.job_change.after_position = data.after_position
        this.job_change.before_is_cloth_subsidy = data.before_is_cloth_subsidy
        this.job_change.after_is_cloth_subsidy = data.after_is_cloth_subsidy
        this.job_change.before_dept = data.before_dept
        this.job_change.after_dept = data.after_dept
        this.salary_change.before_salary_type = data.before_salary_type
        this.salary_change.after_salary_type = data.after_salary_type
        this.salary_change.before_salary = data.before_salary
        this.salary_change.after_salary = data.after_salary
        this.salary_change.before_salary_allowance = data.before_salary_allowance
        this.salary_change.after_salary_allowance = data.after_salary_allowance
        this.salary_change.before_salary_subsidy = data.before_salary_subsidy
        this.salary_change.after_salary_subsidy = data.after_salary_subsidy
        this.salary_change.before_is_customization_subsidy = data.before_is_customization_subsidy
        this.salary_change.after_is_customization_subsidy = data.after_is_customization_subsidy
        this.salary_change.before_is_salary_car = data.before_is_salary_car
        this.salary_change.after_is_salary_car = data.after_is_salary_car
        this.salary_change.before_is_salary_house = data.before_is_salary_house
        this.salary_change.after_is_salary_house = data.after_is_salary_house
        this.salary_change.before_is_salary_on_job = data.before_is_salary_on_job
        this.salary_change.after_is_salary_on_job = data.after_is_salary_on_job
        this.salary_change.before_is_salary_full_attendance = data.before_is_salary_full_attendance
        this.salary_change.after_is_salary_full_attendance = data.after_is_salary_full_attendance
        this.salary_change.before_is_salary_work_year = data.before_is_salary_work_year
        this.salary_change.after_is_salary_work_year = data.after_is_salary_work_year
        this.file_id = data.file_id
        this.record_item_time = data.record_item_time
        this.attach_photo_id = data.attach_photo_id
        this.attach_photo_id_obj = data.attach_photo_id_obj
        this.isEdit = true
      }
    },


    async getOptions() {
      let data = await this.$http("employeeChangeRecordService.getAllOptionsCaseStatus");
      this.options.position_options = data.position_options
      /*this.options.status_options = data.status_options*/
      this.options.employee_type_options = data.employee_type_options
      this.options.salary_type_options = data.salary_type_options
      this.options.rank_options = data.rank_options
    },
    //获取新增和编辑的异动类型下拉框
    async getAddChangeOptionsOptions() {
      let data = await this.$http("employeeChangeRecordService.getChangeItemsOptions");
      this.options.change_item_id_options = data.change_item_id_options
    },
    //获取详细的异动类型下拉框
    async getDetailChangeOptionsOptions() {
      let data = await this.$http("employeeChangeRecordService.getDetailChangeItemsOptions");
      this.options.change_item_id_options = data.change_item_id_options
    },
    async getDepartmentCascader() {
      this.deptCascader = await this.$http("sysUserDepartmentService.getDepartmentData");
    },
    //获取外调部门
    async getAfterDepartment(){
      this.department_ids = '';
      let params = {factory_id: this.factory_id}
      this.aterDeptCascader = await this.$http('sysUserDepartmentService.getAfterDeptData', params);
    },
    //获取职位
    async getPositionOption() {
      let params = {group_id: "职位"}
      this.positionOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    async employeeNoChange() {
      if (this.employee_no === ''){
        return
      }
      let params = {
        employee_no: this.employee_no
      }
      let data = await this.$http("employeeInfoService.getByEmployeeNoWithSalary", params);
      if (!data) {
        this.$message.error("该员工不存在或已离职！");
        this.employee_name = '';
        this.before_factory_id = '';
        this.before_company_id = '';
        this.company_name = '';
        this.before_department_ids = '';
        this.before_position_id = '';
        this.before_job_id = '';
        this.job_change.before_type = ''
        /*this.job_change.before_status = ''*/
        this.job_change.before_position = ''
        /*    this.job_change.before_level = ''*/
        this.job_change.before_dept = ''
        this.salary_change.before_salary_type = ''
        this.salary_change.before_salary = ''
        this.salary_change.before_salary_allowance = ''
        this.salary_change.before_salary_subsidy = ''
        this.salary_change.before_is_customization_subsidy = false
        this.salary_change.before_is_salary_car = false
        this.salary_change.before_is_salary_house = false
        this.salary_change.before_is_salary_on_job = false
        this.salary_change.before_is_salary_full_attendance = false
        this.salary_change.before_is_salary_work_year = false
        return
      }
      this.employee_name = data.employee_name
      this.before_factory_id = data.factory_id;
      this.before_company_id = data.company_id;
      this.company_name = data.company_name;
      this.before_department_ids = data.main_department_id;
      this.before_position_id = data.position_id;
      this.before_job_id = data.job_id;
      this.job_change.before_type = data.employee_type
      /*this.job_change.before_status = data.user_status*/
      this.job_change.before_position = data.position_id
      /*  this.job_change.before_level = data.position_level*/
      this.job_change.before_dept = data.department_ids
      this.job_change.before_is_cloth_subsidy = data.is_cloth_subsidy
      this.salary_change.before_salary_type = data.salary_type_id
      this.salary_change.before_salary = data.salary
      this.salary_change.before_salary_allowance = data.salary_allowance
      this.salary_change.before_salary_subsidy = data.salary_subsidy
      this.salary_change.before_is_customization_subsidy = data.is_customization_subsidy
      this.salary_change.before_is_salary_car = data.salary_car
      this.salary_change.before_is_salary_house = data.salary_house
      this.salary_change.before_is_salary_on_job = data.salary_on_job
      this.salary_change.before_is_salary_full_attendance = data.salary_full_attendance
      this.salary_change.before_is_salary_work_year = data.salary_work_year
    },

    async salaryTypeChange() {
      if (this.salary_change.after_salary_type == null) {
        return
      }
      this.salary_change.after_is_customization_subsidy = false
      this.salary_change.after_is_salary_car = false
      this.salary_change.after_is_salary_house = false
      this.salary_change.after_is_salary_on_job = false
      this.salary_change.after_is_salary_full_attendance = false
      this.salary_change.after_is_salary_work_year = false

      let params = {
        salary_type: this.salary_change.after_salary_type
      }
      let data = await this.$http("employeeChangeRecordService.salaryTypeChange", params);
      this.salary_change.after_is_salary_car = Boolean(data.salary_car)
      this.salary_change.after_is_salary_house = Boolean(data.salary_house)
      this.salary_change.after_is_salary_on_job = Boolean(data.salary_on_job)
      this.salary_change.after_is_salary_full_attendance = Boolean(data.salary_full_attendance)
      this.salary_change.after_is_salary_work_year = Boolean(data.salary_work_year)
    },
    async openCameraMain(){
      this.dialogVisibleTwo = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisibleTwo = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisibleTwo = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
  },
  created() {
    this.getCompany();
    this.getData().then(() => {
      this.getAttachments();
    });
    this.getAddChangeOptionsOptions();
    this.getOptions()
    this.getDepartmentCascader()
    this.getPositionOption()
    this.getFactory();
  },
  watch: {
    'salary_change.after_is_customization_subsidy'(newVal) {
      if (!newVal) {
        this.salaryTypeChange()
      }
    }
  }

}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid black;
  border-radius: 5px;
  border-color: #cccccc;
  margin: 10px 0;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
}

.custom-label {
  font-size: 16px;
  font-weight: bold;
}


</style>